import { Flex, IconWrap, SortDefaultIcon, Text } from '@libs/ui/ds'
import { useCommonAppTranslation } from '@libs/utils/translations'
import type { MembershipModel } from '@spa/scenes/Plannings/redux/models/Membership'
import React from 'react'
import type { FC } from 'react'

type Props = {
  membership: MembershipModel
}
export const MembershipSortFormItem: FC<Props> = ({ membership }) => {
  const { t } = useCommonAppTranslation()

  return (
    <Flex
      row
      className='mb-3 box-border h-9 cursor-grab items-center gap-5 rounded bg-neutral-100 px-3 shadow-sm'
    >
      <IconWrap icon={<SortDefaultIcon />} size='l' />
      <Text className='text-s font-medium'>
        {t('models.fullname', {
          value: {
            firstname: membership?.firstname,
            lastname: membership?.lastname
          }
        })}
      </Text>
    </Flex>
  )
}
